export default "__VITE_ASSET__NP$sJnro__"